import { BorderRadius, Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  tableFooterRow: {
    width: '100%',
    padding: 12,
    borderWidth: 1,
    borderBottomLeftRadius: BorderRadius.R8,
    borderBottomRightRadius: BorderRadius.R8,
    borderColor: Color.Grey200,
    borderTopColor: Color.Grey500,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 'bold',
  },
})
